import { Injectable } from '@angular/core';
import { HttpGeneralService } from '../../../shared/shared';
import { CONFIG } from '../../../shared/config';
import { PatientVM } from '../../patients';
import { BfConsultantInterview } from '../birth-data';
const NicuVaccineSchedualUrl = CONFIG.baseUrls.NicuVaccineSchedual;
const patientsUrl = CONFIG.baseUrls.patients;

///patent cancel url

export interface NicuVaccinTrans {
    serial: number;
    newBornCode: number;
    vaccinSerial: number;
    vaccinNameAr: string;
    vaccinNameEn: string;
    vaccinationDate: Date;
    docId: number;
    inOutHospitalFalg: number;
    updatestatus?: number;
    dataStatus?: number;
    notes?: string;
}


@Injectable({
    providedIn: 'root'
  })
  export class NicuVaccineScheduleService {
    constructor(
        private httpGeneralService: HttpGeneralService) {
    }

    getMotherPat(_PatientVM: PatientVM) {
        return this.httpGeneralService.add(_PatientVM, `${NicuVaccineSchedualUrl}/getBirthData`)
    }

    getNicuVaccin(newBornCode: number) {
        return this.httpGeneralService.get(newBornCode, `${NicuVaccineSchedualUrl}/getNicuVaccinSchedual`)
    }

    addNicuVaccineSchedule(_NicuVaccinTrans: NicuVaccinTrans[]) {
        return this.httpGeneralService.addCollection(_NicuVaccinTrans, `${NicuVaccineSchedualUrl}/addNicuVaccineSchedule`);
    }

    deleteNicuVaccineSchedule(code: number) {
        return this.httpGeneralService.delete(code, `${NicuVaccineSchedualUrl}/deleteNicuVaccineSchedule`);
      }
    

    addBfConsultantInterview(bfConsultantInterview: BfConsultantInterview[]) {
        return this.httpGeneralService.addCollection(bfConsultantInterview, `${NicuVaccineSchedualUrl}/addBfConsultantInterview`)
    }
    getbfConsultantInterview(bfConsultantInterview: BfConsultantInterview) {
        return this.httpGeneralService.add(bfConsultantInterview, `${NicuVaccineSchedualUrl}/getbfConsultantInterview`)
    }
    deletebfConsultantInterview(serial: number) {
        return this.httpGeneralService.delete(serial, `${NicuVaccineSchedualUrl}/deletebfConsultantInterview`);
    }
    updatebfConsultantInterview(bfConsultantInterview: BfConsultantInterview) {
        return this.httpGeneralService.update(bfConsultantInterview.serial, bfConsultantInterview, `${NicuVaccineSchedualUrl}/PutSbfConsultantInterview`);
    }

}




